import { CSS, StyleProps } from "@shared/primitive-components"

export const fullWidth = (): CSS => ({
  width: `100%`,
  padding: `0`,
})

export const mapContainer = (): CSS => ({
  zIndex: 1,
})

export const vehicleLink = (): CSS => ({
  textDecoration: `underline`,
  cursor: `pointer`,
})

export const marginBottom = (props: StyleProps): CSS => ({
  marginBottom: props.theme.spacing(6),
})

export const detailCard = (): CSS => ({
  height: `100%`,
})

export const detailHeading = (props: StyleProps): CSS => ({
  textTransform: `uppercase`,
  fontSize: props.theme.fontSize.body,
  marginBottom: props.theme.spacing(2),
})

export const vehicleDetail = (props: StyleProps): CSS => ({
  width: `100%`,
  padding: `0`,
  marginBottom: props.theme.spacing(6),
})

export const notificationCopy = (props: StyleProps): CSS => ({
  fontSize: props.theme.fontSize.body,
  color: props.theme.palette.white,
})
